import * as d3 from "d3";
import { getIndexes } from "common/utils";
import { csvName, safeStr, safeSubsId } from "common/api";

export function parseApplicationMetrics(input, mode, bqnId) {
  const [header, ...rows] = input.trim().split("\n");
  const headerIndexes = getIndexes(header);

  const result = {}

  for (let row of rows) {
    const attrs = row.trim().split(/\s+/);
    const count = parseInt(attrs[headerIndexes["COUNTS"]]);

    if (count < 100) {
      continue;
    }

    const bqn = bqnId;

    if(!result[bqn]){
      result[bqn] = {downlink: [], uplink: []}
    }
    const entry = result[bqn];

    const item = {
      app: attrs[headerIndexes["APP"]],
      min: parseFloat(attrs[headerIndexes["MIN-MBPS"]]),
      p10: parseFloat(attrs[headerIndexes["10%-MBPS"]]),
      p25: parseFloat(attrs[headerIndexes["25%-MBPS"]]),
      p50: parseFloat(attrs[headerIndexes["50%-MBPS"]]),
      p75: parseFloat(attrs[headerIndexes["75%-MBPS"]]),
      p90: parseFloat(attrs[headerIndexes["90%-MBPS"]]),
      max: parseFloat(attrs[headerIndexes["MAX-MBPS"]]),
    };

    const direction = attrs[headerIndexes["DIR"]];

    if (direction === "down") {
      entry.downlink.push(item);
    } else if (direction === "up") {
      entry.uplink.push(item);
    }
  }

  return result;
}

// The names selected that the BQN reports: filtering by a name it does not
// report leaves the metrics empty. The selection is left as it is when every
// name of it is still reported, so that nothing is asked again for it.
export const namesReported = (names) => (selected) => {
  const kept = selected.filter((name) => names.includes(name));

  return kept.length === selected.length ? selected : kept;
};

export function getPolicyFilterCmd(policiesRateSelected) {
  if (policiesRateSelected.length === 0) {
    return "all";
  } else {
    return `name '${policiesRateSelected
      .map((policy) => `"${policy.replaceAll('"', '""')}"`)
      .join(",")}'`;
  }
}

export function getSubscriberGroupFilterCmd(subscriberGroupSelected) {
  if (subscriberGroupSelected.length === 0) {
    return "all";
  } else {
    return `name '${subscriberGroupSelected
      .map((sub) => csvName(sub))
      .join(",")}'`;
  }
}

export function getCategoryFilterCmd(category) {
  if (category === "All-apps" || category === "Global") {
    return "all";
  } else {  
    return `name "${safeStr(category).replaceAll('\'', '')}"`;
  }
}

export const parsePolicyNames = (response) => {
  const [_head, ...rows] = response.trim().split("\n");
  const headerIndexes = getIndexes(_head);
  return Array.from(
    new Set(rows.map((row) => row.trim().split(/\s+/)[headerIndexes["NAME"]]))
  );
};

export const parseSubscriberGroupsNames = (response) => {
  const [_head, ...rows] = response.trim().split("\n");
  const headerIndexes = getIndexes(_head);

  return Array.from(
    new Set(
      rows.map((row) => row.trim().split(/\s+/)[headerIndexes["SUBSCRIBER-GROUP"]])
    )
  );
};

const parseDate = d3.timeParse("%Y-%m-%dT%H:%M:%S");

export function parseTimeEvolution(response){
  const [header, ...rows] = response.trim().split("\n");
  const headerIndexes = getIndexes(header);
  const parsedDate = rows.reduce((acc, row) => {  
    const attrs = row.trim().split(/\s+/);
    const itemDownlink ={
      
      time: new Date(parseDate(attrs[headerIndexes["TIME"]])),
      min: parseFloat(attrs[headerIndexes["D-MIN-MBPS"]]),
      p10: parseFloat(attrs[headerIndexes["D-10%-MBPS"]]),
      p25: parseFloat(attrs[headerIndexes["D-25%-MBPS"]]),
      p50: parseFloat(attrs[headerIndexes["D-50%-MBPS"]]),  
      p75: parseFloat(attrs[headerIndexes["D-75%-MBPS"]]),
      p90: parseFloat(attrs[headerIndexes["D-90%-MBPS"]]),
      max: parseFloat(attrs[headerIndexes["D-MAX-MBPS"]]),
    }
    const itemUplink ={
      time: new Date(parseDate(attrs[headerIndexes["TIME"]])),
      min: parseFloat(attrs[headerIndexes["U-MIN-MBPS"]]),
      p10: parseFloat(attrs[headerIndexes["U-10%-MBPS"]]),
      p25: parseFloat(attrs[headerIndexes["U-25%-MBPS"]]),
      p50: parseFloat(attrs[headerIndexes["U-50%-MBPS"]]),  
      p75: parseFloat(attrs[headerIndexes["U-75%-MBPS"]]),
      p90: parseFloat(attrs[headerIndexes["U-90%-MBPS"]]),
      max: parseFloat(attrs[headerIndexes["U-MAX-MBPS"]]),
    }
    acc.downlink.push(itemDownlink);
    acc.uplink.push(itemUplink);
    return acc;
  }, {downlink: [], uplink: []});
  return parsedDate;
}

export function getCmdSubscriber(target) {
  if (!target) return "all";
  const { addr, subsId } = target;
  return addr ? addr : `id ${safeSubsId(subsId)}`;
  }
  
export function getCmdSubscribergroup(group) {
      if (!group) return "all";
      return `name '${csvName(group)}'`;
  }
